import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { setApplicationNotificationsBridgeContext, getApplicationNotificationsBridgeContext, } from './bridge';
import { DebuggingNotifier } from './debuggingNotifier';
import { PageBannerNotifier } from './pageBannerNotifier';
import { OverlayBannerNotifier } from './overlayBannerNotifier';
import { ToastNotifier } from './toastNotifier';
import { getNullApplicationNotifications } from './getNullApplicationNotifications';
import { NOTIFICATION_ROLES, DEFAULT_NOTIFICATION_OPTIONS } from './constants';
import { useMountEffect } from '../../hooks';
const ApplicationNotificationsContext = createContext({
    debugger: new DebuggingNotifier(),
    toast: new ToastNotifier(),
    overlayBanner: new OverlayBannerNotifier(),
    pageBanner: new PageBannerNotifier(),
    roles: NOTIFICATION_ROLES,
});
const ApplicationNotificationsConsumer = ApplicationNotificationsContext.Consumer;
function ApplicationNotificationsProvider({ children, pageBannerContainerRef, }) {
    const notifierRef = useRef(null);
    const [debuggerNotifier, setDebuggerNotifier] = useState(new DebuggingNotifier());
    const [toastNotifier, setToastNotifier] = useState(new ToastNotifier());
    const [overlayBannerNotifier, setOverlayBannerNotifier] = useState(new OverlayBannerNotifier());
    const [pageBannerNotifier, setPageBannerNotifier] = useState(new PageBannerNotifier());
    notifierRef.current = {
        debuggerNotifier,
        toastNotifier,
        overlayBannerNotifier,
        pageBannerNotifier,
    };
    useMountEffect(() => {
        debuggerNotifier.initialize();
        toastNotifier.initialize();
        overlayBannerNotifier.initialize();
        pageBannerNotifier.initialize(pageBannerContainerRef);
        setDebuggerNotifier(debuggerNotifier);
        setToastNotifier(toastNotifier);
        setOverlayBannerNotifier(overlayBannerNotifier);
        setPageBannerNotifier(pageBannerNotifier);
        return () => {
            if (notifierRef.current) {
                const { debuggerNotifier, toastNotifier, overlayBannerNotifier, pageBannerNotifier, } = notifierRef.current;
                debuggerNotifier.destroy?.();
                toastNotifier.destroy?.();
                overlayBannerNotifier.destroy?.();
                pageBannerNotifier.destroy?.();
            }
        };
    });
    const context = {
        debugger: debuggerNotifier,
        toast: toastNotifier,
        overlayBanner: overlayBannerNotifier,
        pageBanner: pageBannerNotifier,
        roles: NOTIFICATION_ROLES,
    };
    setApplicationNotificationsBridgeContext(context);
    return (_jsx(ApplicationNotificationsContext.Provider, { value: context, children: children }));
}
ApplicationNotificationsProvider.propTypes = {
    children: PropTypes.node.isRequired,
    pageBannerContainerRef: PropTypes.object,
};
const useApplicationNotifications = () => {
    const context = useContext(ApplicationNotificationsContext);
    return context;
};
const withApplicationNotificationsContext = (Component) => (props) => (_jsx(ApplicationNotificationsContext.Consumer, { children: context => _jsx(Component, { ...props, notifications: context }) }));
const MockApplicationNotificationsProvider = ({ children, context, }) => (_jsx(ApplicationNotificationsContext.Provider, { value: context, children: children }));
MockApplicationNotificationsProvider.propTypes = {
    children: PropTypes.node,
    context: PropTypes.object,
};
export { ApplicationNotificationsProvider, ApplicationNotificationsConsumer, useApplicationNotifications, withApplicationNotificationsContext, getApplicationNotificationsBridgeContext, NOTIFICATION_ROLES, DEFAULT_NOTIFICATION_OPTIONS, getNullApplicationNotifications, MockApplicationNotificationsProvider, };
//# sourceMappingURL=index.js.map